var transform = {
  serializeIn: function serializeIn(settings) {
    var formatValues = settings.formatValues,
        theme = settings.theme;
    return {
      funnelPercentages: theme.funnel.header.badge.enabled,
      formatValue: typeof formatValues === 'string' ? formatValues : null
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatValue = _ref.formatValue,
        funnelPercentages = _ref.funnelPercentages;
    return {
      formatValues: formatValue,
      theme: {
        funnel: {
          header: {
            badge: {
              enabled: funnelPercentages
            }
          }
        }
      }
    };
  }
};
export default transform;